import { http } from "@/http";

export const setStudyProgressVisible = async(id:string, v:boolean):Promise<void> => {
	await http.patch(`studies/${id}/settings`, { showProgress:v });
};